
























































import { computed, defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    shopTypes: {
      type: Array as PropType<string[]>,
      default: null,
    },
    shopWineDrink: {
      type: Boolean,
      default: false,
    },
    hasCellar: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    /** ショップタイプが該当するか否か */
    const isType = (type: string) => {
      if (props.shopTypes) {
        return props.shopTypes.find((shopType) => shopType === type);
      }
      return false;
    };

    const discountMessage = computed(() => {
      if (props.hasCellar) {
        return i18n.t('Other-03.shopType.visaAndCellarDiscount').toString();
      }
      return i18n.t('Other-03.shopType.visaDiscountOnly').toString();
    });

    return { isType, discountMessage };
  },
});
